export default __webpack_public_path__ + "static/media/deliveryVisuals.5dae5bae.png";